import React, { useState } from "react";
import VaulDrawer from "../BottomSheetComponents/VaulDrawer";
import UnlockEliteBottomSheet from "../BottomSheetComponents/UnlockEliteBottomSheet";
import { EliteIconExhausted } from "../../icons/EliteIconExhausted";

// TODO: Replace these URLs with local assets if available
const imgGamingAwardPrize = "http://localhost:3845/assets/40e933520a50d87e88fa2045f48fd576948408dd.svg";
const imgGamingAwardPrize1 = "http://localhost:3845/assets/188f67a50e803377c323dd3b3fbbde9b876eeb63.svg";

const EliteOfferExhausted = ({ fundCategory }: any) => {
    const [openBottomSheet, setOpenBottomSheet] = useState(false)
    return (
        <div className="bg-[#ffffff] relative rounded-xl w-full" data-testid="elite-offer-badge">
            <div className="flex flex-col items-center relative w-full">
                <div className="box-border flex flex-col gap-3 items-center justify-start px-[7px] py-4 min-w-[150px]">
                    <div className="box-border flex flex-col gap-2 items-center w-full">
                        <div className="box-border flex flex-row items-center justify-center pl-2 pr-2.5 relative rounded-[10px] bg-white">
                            <EliteIconExhausted />
                        </div>
                        <div className="font-medium text-[#232323] text-[13px] text-center">
                            <p className="leading-[1.4]">See Elite Scores for {fundCategory}</p>
                        </div>
                    </div>
                    <div className="font-medium text-grey40 text-[13px] text-center whitespace-nowrap">
                        <p className="leading-[1.3]">Free Trial Exhausted</p>
                    </div>
                </div>
            </div>
            <VaulDrawer open={openBottomSheet} setOpen={setOpenBottomSheet}>
                <UnlockEliteBottomSheet fundCategory={fundCategory} onDismiss={() => setOpenBottomSheet((open) => !open)} />
            </VaulDrawer>
        </div>
    );
};

export default EliteOfferExhausted; 